const admissionTicket = [{
  path: 'admissionTicket/index',
  component: resolve => require(['../../../../components/pages/studentresults/admissionTicket'], resolve)
}]
export default admissionTicket
